module.exports = "ul {\r\n    width: 100%;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n        flex-wrap: wrap;\r\n}\r\n\r\nimg {\r\n    max-width: 100%;\r\n}\r\n\r\n.image-list{\r\n    padding: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/image-resizer-list/image-resizer-list.component.css
// module id = ./src/app/image-resizer-list/image-resizer-list.component.css
// module chunks = main